import { render, staticRenderFns } from "./association.vue?vue&type=template&id=424f93dc&scoped=true&"
import script from "./association.vue?vue&type=script&lang=js&"
export * from "./association.vue?vue&type=script&lang=js&"
import style0 from "./association.vue?vue&type=style&index=0&id=424f93dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424f93dc",
  null
  
)

export default component.exports